export default {
  summaryLine: '{series} séries · {rows} linhas',
  startDateHelp: 'Cada linha é contada no período que contém sua Start Date. Períodos sem linhas ficam vazios, não em zero.',
  week: 'Semanal',
  month: 'Mensal',
  quarter: 'Trimestral',
  year: 'Anual',
  metric: 'Métrica',
  filter: 'Filtro',
  variable: 'Variável',
  allVariables: 'Todas as variáveis',
  byVariable: 'Por variável',
  allData: 'Todos os dados',
  blankValue: '(vazio)',
  filterUnavailableValues: 'Valores demais para filtrar',
  filterUnavailableSize: 'Indisponível para um template deste tamanho',
  flaggedOnly: 'Só séries a revisar',
  showSpecialDates: 'Mostrar datas especiais',
  fixedDims: 'Todas as linhas têm {list}',
  bucketedNotice: 'Esta aba tem dados diários, então a visão mais detalhada é semanal.',
  noSeries: 'Nenhuma série corresponde a esta seleção',
  coverageTitle: 'Cobertura',
  coverageHelp: 'Cada linha é uma série e cada coluna um período. Células mais escuras são valores mais altos dentro da série; células brancas são períodos sem dados. Procure lacunas e séries que começam ou terminam em datas estranhas.',
  coverageHelpByBrand: 'Cada linha é um concorrente (todas as suas mídias somadas) e cada coluna um período. Células mais escuras são valores mais altos dentro do concorrente; células brancas são períodos sem dados. Procure lacunas e concorrentes que começam ou terminam em datas estranhas.',
  seriesTitle: 'Séries',
  showMore: 'Mostrar mais {count}',
  issueMissingColumns: 'Colunas não encontradas: {list}',
  issueBadDates: '{count} linhas foram ignoradas porque não foi possível ler sua Start Date.',
  issueTextDates: '{count} linhas têm datas digitadas como texto. Confira se dias e meses não estão trocados.',
  issueNonNumeric: '{count} valores não são números e ficaram de fora.',
  issueDroppedSeries: 'Mostrando as {shown} séries com mais linhas (outras {hidden} não aparecem).'
}
